import React from "react";
import { Form } from "semantic-ui-react";

interface StaffLocationTabChangeLocationModalLocationLabelProps {
  allowEnterManually?: boolean;
  enteringManually?: boolean;
  onEnterManually?: () => void;
  onReturnToLocationSearch?: () => void;
}
export default function StaffLocationTabChangeLocationModalLocationLabel({
  allowEnterManually = false,
  enteringManually = false,
  onEnterManually = () => {},
}: StaffLocationTabChangeLocationModalLocationLabelProps) {
  const label = "Search by address, name, or parcel #" as const;
  if (!allowEnterManually) {
    return <label>{label}</label>;
  }

  if (enteringManually) {
    return <></>;
  }

  return (
    <div className='tw-mb-1 tw-flex tw-justify-between tw-font-bold'>
      <Form.Field className='tw-mb-0' required>
        <label>{label}</label>
      </Form.Field>
      <button
        onClick={onEnterManually}
        className='tw-border-none tw-bg-transparent tw-text-blue hover:tw-cursor-pointer hover:tw-underline'
      >
        Enter Manually
      </button>
    </div>
  );
}
